<nav *ngIf="mapViewReady" class="navbar navbar-expand-md navbar-dark nav-umwelt-gis">
  <a
    class="navbar-brand navbar-sidebar"
    [routerLink]="[router.url]"
    id="menu-toggle"
    (click)="toggleSidebar()"
  >
    <span class="esri-icon-drag-horizontal" aria-hidden="true"></span>
  </a>
  <a class="navbar-brand" translate>HEADER_PANEL.APP_TITLE</a>
  <div class="collapse navbar-collapse" id="navbarCollapse">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" (click)="setInitialExtent()" translate>
          <span class="esri-icon-home">&nbsp;</span>HEADER_PANEL.HOME</a
        >
      </li>
      <li class="nav-item dropdown">
        <arbeitsbereich dropdown></arbeitsbereich>
      </li>
    </ul>
    <ul class="navbar-nav ms-auto">
      <li class="nav-item search-margin-right">
        <search></search>
      </li>

      <li class="nav-item dropdown">
        <custom-searches dropdown></custom-searches>
      </li>

      <li class="nav-item">
        <a class="nav-link goto" (click)="showGoToWidget()" translate
          ><span class="esri-icon-applications">&nbsp;</span>HEADER_PANEL.GOTO</a
        >
      </li>

      <li class="nav-item">
        <a class="nav-link user" (click)="showUserWidget()">
          <i class="material-icons md-18 md-nav-align">person</i>{{ user?.userId }}
        </a>
      </li>
      <li class="nav-item dropdown">
        <language dropdown></language>
      </li>
    </ul>
  </div>
</nav>
<sidebar [class.toggled]="toggleSidebar$ | async"></sidebar>
